import { httpsCallable } from 'firebase/functions'
import { firebaseFunctions } from './firebase'

export type ProductAnalyticsEventInput = {
  eventType: 'SECTION_OPENED'
  sectionKey: string
  sectionLabel: string
  workspaceId?: string | null
  route: string
  surface: string
}

const recordEvent = httpsCallable<ProductAnalyticsEventInput, { ok: true; eventId: string }>(
  firebaseFunctions,
  'recordProductAnalyticsEvent',
)

const productAnalyticsEnabled = import.meta.env.VITE_ENABLE_PRODUCT_ANALYTICS === 'true'

export const recordProductAnalyticsEvent = async (input: ProductAnalyticsEventInput) => {
  if (!productAnalyticsEnabled) return { ok: true as const, eventId: 'disabled' }
  return (await recordEvent(input)).data
}
